import { render } from "./MobileDefaultLayout.vue?vue&type=template&id=23dabbcd"
import script from "./MobileDefaultLayout.vue?vue&type=script&lang=js"
export * from "./MobileDefaultLayout.vue?vue&type=script&lang=js"

import "./MobileDefaultLayout.vue?vue&type=style&index=0&id=23dabbcd&lang=css"

import exportComponent from "../../../../../../../../../../Desktop/중요/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__